// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { SocialItemType } from "features/config/types";

const ShareTwitter: React.FC<{ social: SocialItemType; text: string }> = ({ social, text = "" }) => {
  return (
    <div>
      <a
        href={`https://twitter.com/share?url=${text}`}
        className="twitter-share-button"
        data-show-count="false"
        target="_blank"
        rel="noreferrer"
        data-size="large"
        data-url={text}
      >
        <img src={social.icon} alt={social.name} title={social.name} className="w-6 h-5" />
      </a>
      <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
    </div>
  );
};

export default ShareTwitter;
